const units = {
    "kWh": ["MWh", "GWh"],
    "kW": ["MW", "GW"],
    "kVArh": ["MVArh", "GVArh"],
    "kVAr": ["MVAr", "GVAr"],
};

export const unitConverterArrays = (kWhArray, unit) => {//Converte um conjunto de arrays com valores [[111,2,331],[1,2,3]] para a unidade correta (kWh, MWh, GWh)
    let hasMillion = false;
    let hasThousands = false;

    // Verificar se algum valor está na casa de milhões ou milhares
    for (const linha of kWhArray) {
        for (const valor of linha) {
            if (valor >= 1_000_000) {
                hasMillion = true;
                break;
            } else if (valor >= 1_000) {
                hasThousands = true;
            }
        }
        if (hasMillion) break;
    }

    // Converter os valores conforme necessário
    for (let i = 0; i < kWhArray.length; i++) {
        for (let j = 0; j < kWhArray[i].length; j++) {
            if (kWhArray[i][j] === null) {
                continue; // Se for null, não faz nada e continua o loop
            }

            if (hasMillion) {
                kWhArray[i][j] /= 1_000_000; // Converter para GWh
            } else if (hasThousands) {
                kWhArray[i][j] /= 1_000; // Converter para MWh
            }
        }
    }

    // Determinar a unidade correta
    const newUnit = hasMillion ? units[unit][1] : (hasThousands ? units[unit][0] : unit);

    return { convertedResult: kWhArray, newUnit }; // Retornar o resultado e a unidade
}

export const unitConvertSingleValue = (value, unit) => {//Convert um valor unico para a unidade correta
    let newUnit;
    
    if (value >= 1_000_000) {
        value /= 1_000_000; // Converter para GWh
        newUnit = units[unit]?.[1];
    } else if (value >= 1_000) {
        value /= 1_000; // Converter para MWh
        newUnit = units[unit]?.[0];
    } else {
        newUnit = unit; // Manter em kWh
    }

    return { result: value, newUnit }; // Retornar o valor e a unidade
}

export const unitConvertArrayOfObject = (arrayOfObjects, unit) => {
    let hasMillion = false;
    let hasThousands = false;

    // Verificar se algum valor está na casa de milhões ou milhares
    for (const item of arrayOfObjects) {
        if (item.y >= 1_000_000) {
            hasMillion = true;
            break;
        } else if (item.y >= 1_000) {
            hasThousands = true;
        }
    }

    // Converter os valores conforme necessário
    for (const item of arrayOfObjects) {
        if (item.y === null) {
            continue; // Se for null, não faz nada e continua o loop
        }

        if (hasMillion) {
            item.y /= 1_000_000; // Converter para GWh
        } else if (hasThousands) {
            item.y /= 1_000; // Converter para MWh
        }
    }

    // Determinar a unidade correta
    const newUnit = hasMillion ? units[unit][1] : (hasThousands ? units[unit][0] : unit);

    return { convertedResult: arrayOfObjects, newUnit }; // Retornar o resultado e a unidade
};